import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import DashboardFilters from './DashboardFilters';

const categoryConfig = {
    users: {
        show: true,
        label: 'Type',
        options: [
            { value: 'PET_GUARDIAN', label: 'Pet Guardian' },
            { value: 'VETERINARIAN', label: 'Vet' },
            { value: 'SERVICE_PROVIDER', label: 'Service Provider' },
            { value: 'FIRM', label: 'Firm' }
        ]
    },
    social: {
        show: true,
        label: 'Type',
        options: [
            { value: 'post', label: 'Post' },
            { value: 'poll', label: 'Poll' },
            { value: 'adoption', label: 'Adoption' }
        ]
    },
    medical: {
        show: true,
        label: 'Status',
        options: [
            { value: 'pending', label: 'Pending' },
            { value: 'confirmed', label: 'Confirmed' },
            { value: 'completed', label: 'Completed' },
            { value: 'cancelled', label: 'Cancelled' }
        ]
    },
    overview: {
        show: false
    }
};

const getTabFromTitle = (title) => {
    if (title.includes('User')) return 'users';
    if (title.includes('Social')) return 'social';
    if (title.includes('Medical')) return 'medical';
    return 'overview';
};

const DetailedPageLayout = ({ title, children, onFilterChange, filters, isSubView = false }) => {
    const navigate = useNavigate();
    const [showFilters, setShowFilters] = useState(false);
    const activeTab = getTabFromTitle(title);

    const handleFilterChange = (newFilters) => {
        if (onFilterChange) onFilterChange(newFilters);
    };

    if (isSubView) {
        return (
            <div className="tab-content sd-detailed-content">
                {children}
            </div>
        );
    }

    return (
        <div className="dashboard-container">
            <div className="dashboard-content">
                <div className="detailed-page-header-sticky">
                    <div className="dashboard-header-mini sd-detailed-header">
                        <div className="sd-detailed-header__left">
                            <button
                                onClick={() => navigate(-1)}
                                className="sd-detailed-header__back"
                                title="Back to Dashboard"
                            >
                                <ArrowLeft size={20} />
                            </button>
                            <div>
                                <h1 className="sd-detailed-header__title">{title}</h1>
                                <p className="sd-detailed-header__subtitle">Detailed statistics and analytics</p>
                            </div>
                        </div>
                        <button
                            onClick={() => setShowFilters(!showFilters)}
                            className="sd-filter-toggle"
                        >
                            {showFilters ? 'Hide Filters' : 'Show Filters'}
                        </button>
                    </div>

                    {showFilters && (
                        <div className="sd-detailed-filters">
                            <DashboardFilters
                                currentFilters={filters}
                                onFilterChange={handleFilterChange}
                                showCategoryFilter={categoryConfig[activeTab]?.show}
                                categoryLabel={categoryConfig[activeTab]?.label}
                                categories={categoryConfig[activeTab]?.options}
                                activeTab={activeTab}
                            />
                        </div>
                    )}
                </div>

                <div className="tab-content sd-detailed-content">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default DetailedPageLayout;
